import { render, staticRenderFns } from "./printYCRFQ.vue?vue&type=template&id=18034af3&scoped=true&"
import script from "./printYCRFQ.vue?vue&type=script&lang=js&"
export * from "./printYCRFQ.vue?vue&type=script&lang=js&"
import style0 from "./printYCRFQ.vue?vue&type=style&index=0&id=18034af3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18034af3",
  null
  
)

component.options.__file = "printYCRFQ.vue"
export default component.exports